document.addEventListener('DOMContentLoaded', function() {
  const tabCustomElements = document.querySelectorAll('.tabcustom');
  
  tabCustomElements.forEach(tab => {
    const newTab = tab.cloneNode(true);
    
    tab.parentNode.replaceChild(newTab, tab);
    
    newTab.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const targetId = this.getAttribute('data-target');
      const targetContent = document.querySelector(targetId);
      
        setTimeout(() => {
        if (this.classList.contains('collapsed')) {
          this.classList.remove('collapsed');
          targetContent.classList.add('show');
        } else {
          this.classList.add('collapsed');
          targetContent.classList.remove('show');
        }
      }, 10);
      
      return false;
    });
  });
});